// Minimal stub for optional Gemini-based estimations.
// The app falls back gracefully when this returns null.
export async function generateEstimatesWithGemini() {
  return null;
}
